module.exports = __webpack_public_path__ + "static/media/SQSMB.07ca50cd.docx";


//////////////////
// WEBPACK FOOTER
// ./src/authCertificateCompact/modules/attestationType/SQSMB.docx
// module id = 911
// module chunks = 0